export enum EncryptOperation {
    Rotate = 'rotate',
    CreateMasterKey = 'createMasterKey'
}
